import React from 'react'
import NavBar from './NavBar'

const Header = ({ siteTitle }) => (
  <header role="navigation" aria-label="main navigation">
    <div className="container">
        <NavBar />
    </div>
  </header>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/header.js